/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/contractBasedInvoiceHandlers/abortIntegration"/>
import { addHandler } from "Core/Medius.Core.Web/Scripts/Medius/core/customTaskHandlers/customTaskHandlersProvider";
import * as rest from "Core/Medius.Core.Web/Scripts/Medius/core/communication/json/rest";
import { isContractBasedInvoiceRemediumFlowEnabled } from "Core/Medius.Core.Web/Scripts/Medius/core/featureToggle";

export function register() {
    addHandler({
        canHandle: function (vm: any, _task: any) {
            if(isContractBasedInvoiceRemediumFlowEnabled())
            {
                const isRemediumWorkflow = _task.WorkflowContext && _task.WorkflowContext() === null;
                const isErrorCode = vm.Code && vm.Code() === "error";
                const isContractBasedInvoice = _task.Document().$type() === "Medius.ContractbasedInvoice.Entities.ContractbasedInvoice, Medius.ContractbasedInvoice.Common";
                const isPreliminary = _task.ActivityContext().Name() && _task.ActivityContext().Name() === "Preliminary post contractbasedinvoice";
                return isRemediumWorkflow && isContractBasedInvoice && isPreliminary && isErrorCode;
            }

            return false;
        },
        handle: function (task: any, _: any) {
            return function () {
                const request = {
                    UserTaskId: task.Id(),
                    DocumentId: task.Document().Id()
                };
                return rest.post("remedium-api", "contractBasedInvoice/workflow/preliminary/abort", request);
            };
        }
    });
}
